module.exports = __webpack_public_path__ + "static/media/user-manual-mobile.96256af6.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/user-manual-mobile.pdf
// module id = 1616
// module chunks = 0